<div
  id="documentation"
  class="page-layout simple fullwidth inner-scroll flex-column"
>
  <!-- HEADER -->
  <div class="gt2-theme">
    <div
      class="header accent pl-24 pr-24 h-80 mat-elevation-z1 flex-row-start-center"
      fusePerfectScrollbar
      [ngStyle]="{
        width: '100%',
        'overflow-x': isSmallScreen ? 'scroll' : 'none',
      }"
    >
      <div class="flex-row-start-center">
        <mat-icon class="header-page-icon">help</mat-icon>
        <div class="documentation-title">
          {{ "DOCUMENTATION.TITLE" | translate }}
        </div>
      </div>
    </div>
  </div>
  <!-- / HEADER -->


  <!-- GT2 - EN - https://docs.google.com/document/d/e/2PACX-1vSbpWw_RXinSGVQxXyFYxms0ehVhgPO8bcd9RkY0IuKMGMaJPbMJIL2K2QMY1t_2YVsJnvrGBFDGCRO/pub?embedded=true -->

  <iframe
    class="px-24"
    width="100%"
    height="100%"
    *ngIf="translate.currentLang === 'en-CA' && !isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vTEmQuMfhYKy87icOvARta-CBA5fS9TPQIZ3Ugp6Sk7m1v0J-ObOrt6xrZnzbtsQ71rS4fxCRacUTKB/pub?embedded=true"
  >
  </iframe>

    <iframe
    width="100%"
    height="100%"
    class="doc-iframe"
    *ngIf="translate.currentLang === 'en-CA' && isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vTEmQuMfhYKy87icOvARta-CBA5fS9TPQIZ3Ugp6Sk7m1v0J-ObOrt6xrZnzbtsQ71rS4fxCRacUTKB/pub?embedded=true"
  >
  </iframe>

  <!-- GT2 - FR - https://docs.google.com/document/d/e/2PACX-1vQ6IGyBXrI7zrUvEIW1l6qPfP5WVkMPP-F-DhDZgzPzlxw2md_d84ZanzaMCSdQpyn30-pE-m-pAIww/pub?embedded=true -->
  <iframe
    class="px-24"
    width="100%"
    height="100%"
    *ngIf="translate.currentLang === 'fr-CA' && !isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vTO5Aj_ZAjLd396vFv9Q01mpzLf4dNZ59nGrHdggtWwaOtA1DuxpIuQ0Xji4aliMnpJlKpfg8IBdpJD/pub?embedded=true"
  >
  </iframe>

  <iframe
    width="100%"
    height="100%"
    class="doc-iframe"
    *ngIf="translate.currentLang === 'fr-CA' && isMobile"
    src="https://docs.google.com/document/d/e/2PACX-1vTO5Aj_ZAjLd396vFv9Q01mpzLf4dNZ59nGrHdggtWwaOtA1DuxpIuQ0Xji4aliMnpJlKpfg8IBdpJD/pub?embedded=true"
  >
  </iframe>
</div>
